import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminWorkspaceChildList from "@/components/admin/admin-workspace-child-list";

const AdminWorkspaceClientsPage = (): JSX.Element => {
	const { workspaceId } = Route.useParams();
	return <AdminWorkspaceChildList entity="clients" workspaceId={workspaceId} />;
};

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId/clients")({
	component: AdminWorkspaceClientsPage,
});
